import {
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import {
  InsertCompanyBoardInArticlesOfAssociation,
  InsertCompanyBoardInArticlesOfAssociationForm,
} from "./insertCompanyBoardInArticlesOfAssociationDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  _dispatch: DbotEventDispatcher,
  context: DecisionContext<InsertCompanyBoardInArticlesOfAssociation>,
  data?: InsertCompanyBoardInArticlesOfAssociation,
): InsertCompanyBoardInArticlesOfAssociationForm {
  return new InsertCompanyBoardInArticlesOfAssociationForm(context, data);
}

export function applyForm(
  form: InsertCompanyBoardInArticlesOfAssociationForm,
): InsertCompanyBoardInArticlesOfAssociation {
  return {
    type: DecisionType.insertCompanyBoardInArticlesOfAssociation,
    paragraph: form.paragraph.parsedValue,
    texts: form.texts.map((m) => ({
      text: m.model.validatedValue,
      language: m.locale,
    })),
    titles: form.titles.map((m) => ({
      text: m.model.validatedValue,
      language: m.locale,
    })),
  };
}

export function validate(form: InsertCompanyBoardInArticlesOfAssociationForm): boolean {
  return form.validate();
}

export function isValid(form: InsertCompanyBoardInArticlesOfAssociationForm): boolean {
  return form.isValid;
}

export const insertCompanyBoardInArticlesOfAssociationHandler: DecisionTypeHandler<
  DecisionType.insertCompanyBoardInArticlesOfAssociation,
  InsertCompanyBoardInArticlesOfAssociation,
  InsertCompanyBoardInArticlesOfAssociationForm
> = {
  type: DecisionType.insertCompanyBoardInArticlesOfAssociation,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
